import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import noImage from '../../../../assets/images/no-image.png';
import { showBigImage, hideImage, bomConfigData, imageUrl } from '../../../../Components/helper';

function SupplierTodoExapandView(props) {
  const { expandData, item, selectedColumns, t, isSupplierLoggedIn, subBrandAccess } = props;
  return expandData?.map((childItem, childIndex) => {
    let locationVl = `${childItem?.module} > ${childItem?.bomType?.name}`;
    if (childItem?.placement) {
      locationVl += ` > ${childItem.placement}`;
    }

    const fields = childItem?.bomFields
      .map((key) => {
        const configItem = bomConfigData?.find((items) => items?.value === key);
        return configItem ? configItem.label : key; // Fallback to key if no match found
      })
      .join(', ');
    return (
      <tr key={childIndex}>
        <td />
        <td />
        <td>
          <div className="image-detail hover-right">
            <figure onMouseOver={(e) => showBigImage(e)} onMouseLeave={() => hideImage()}>
              <div className="img-preview-inside-table sm">
                <img
                  width="60"
                  alt="product img"
                  src={item.image || noImage}
                  onError={(e) => {
                    e.target.src = noImage;
                  }}
                />
              </div>
            </figure>
          </div>
        </td>

        <td className="last-fix-col">{item?.number || '--'}</td>
        {selectedColumns?.includes('Brand') && <td>{item?.brandId || '--'}</td>}
        {selectedColumns?.includes('Sub Brand') && subBrandAccess && <td>{item?.subBrandId || '--'}</td>}
        {selectedColumns?.includes('Supplier') && <td className="w-150px">{childItem?.suppliers?.[0]?.name || '--'}</td>}
        {selectedColumns?.includes('Season') && <td>{item?.seasonId || '--'}</td>}
        {selectedColumns?.includes('Month') && <td>{item?.month || '--'}</td>}
        {selectedColumns?.includes('Year') && <td>{item?.year || '--'}</td>}
        {selectedColumns?.includes('Category 1') && <td>{item?.catOneId || '--'}</td>}
        {selectedColumns?.includes('Category 2') && <td>{item?.catTwoId || '--'}</td>}
        {selectedColumns?.includes('Category 3') && <td>{item?.catThreeId || '--'}</td>}
        {selectedColumns?.includes('Category 4') && <td>{item?.catFourId || '--'}</td>}
        <td />
        <td>{locationVl || '--'}</td>
        <td>{fields || '--'}</td>
        <td>
          <div className="d-flex align-items-center">
            {isSupplierLoggedIn && (
              <Link className="cursor-pointer text-dark text-decoration-none btn-tbl-action" to={`/supplier-to-do-edit/${childItem._id}/${item._id}`}>
                <span className="icon-edit" />
              </Link>
            )}
            <div className="info-container d-flex text-left">
              <span className="icon-info f-18" />
              <div className="info-content">
                <p className="mb-1">
                  <b>{t('COSTING_TO_DO_LIST.CREATED')} :&nbsp;</b>
                  {moment(childItem?.createdAt).format('DD-MM-YYYY, h:mm a')}
                </p>
                <p className="mb-1">
                  <b>{t('COSTING_TO_DO_LIST.CREATED_BY')} :&nbsp;</b>

                  {childItem?.createdBy?.name}
                </p>
              </div>
            </div>
          </div>
        </td>
      </tr>
    );
  });
}

export default SupplierTodoExapandView;
